import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { propertiesService } from "../services/firebaseServices";
import SEO from "../components/SEO";

const AllHomes = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const data = await propertiesService.getAll();
        setProperties(data);
      } catch (err) {
        console.error("Failed to load properties", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, []);

  if (loading)
    return <div className="pt-40 text-center font-secondary">Loading...</div>;

  return (
    <div className="pt-32 pb-20 max-w-7xl mx-auto px-4">
      <SEO
        title="Luxury Vacation Rentals | ACF Luxury Stays"
        description="Browse our full collection of professionally managed luxury rentals, from ski-in/ski-out mountain chalets to refined coastal escapes and oceanfront residences."
        url="/homes"
      />

      <div className="text-center mb-16">
        <h1 className="text-4xl font-primary text-acf-blue mb-6">
          Explore Our Luxury Vacation Homes
        </h1>
        <p className="font-secondary text-gray-600 max-w-3xl mx-auto text-lg">
          Browse our full collection of professionally managed luxury vacation
          rentals—from ski-in/ski-out mountain homes in Colorado to refined
          coastal escapes in Southern California and oceanfront residences in
          Miami Beach.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {properties.map((property) => (
          <div
            key={property.id}
            className="group flex flex-col bg-white shadow-sm hover:shadow-xl transition-shadow duration-300 rounded-sm overflow-hidden"
          >
            <div className="relative h-64 overflow-hidden">
              <Link to={`/homes/${property.slug || property.id}`}>
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition duration-700"
                />
              </Link>
            </div>

            <div className="p-6 flex flex-col flex-grow">
              <div className="mb-4">
                <p className="text-acf-gold text-xs font-primary uppercase tracking-widest mb-2">
                  {property.location}
                </p>
                <h3 className="text-xl font-primary text-acf-blue mb-2 leading-tight">
                  <Link
                    to={`/homes/${property.slug || property.id}`}
                    className="no-underline text-acf-blue hover:text-acf-gold transition-colors"
                  >
                    {property.title}
                  </Link>
                </h3>
              </div>

              <div className="flex flex-wrap items-center gap-y-2 gap-x-4 border-t border-b border-gray-100 py-3 mb-4 text-xs font-secondary text-gray-500 uppercase tracking-wide">
                <span className="flex items-center gap-1">
                  <strong className="text-acf-blue">{property.guests}</strong>{" "}
                  Guests
                </span>
                <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                <span className="flex items-center gap-1">
                  <strong className="text-acf-blue">{property.bedrooms}</strong>{" "}
                  BR
                </span>
                <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                <span className="flex items-center gap-1">
                  <strong className="text-acf-blue">{property.baths}</strong> BA
                </span>
              </div>

              <Link
                to={`/homes/${property.slug || property.id}`}
                className="inline-block text-center border border-acf-blue text-acf-blue py-3 px-6 text-xs font-primary uppercase tracking-widest hover:bg-acf-blue hover:text-white transition duration-300"
              >
                View Details & Book
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllHomes;
